import { Bar } from "react-chartjs-2";
import { makeStyles } from "@mui/styles";
import BlockSkeleton from "../Skeleton/BlockSkeleton";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const useStyles = makeStyles({
  root: (props) => ({
    position: "relative",
    height: `${Math.max(60, (props.data?.labels?.length || 0) * 1.5)}vh`, // Expand the graph vertically if necessary
    width: "95%",
  }),
});

function BarGraph({ data, title, loading }) {
  const classes = useStyles({ data });

  return (
    <div className={classes.root}>
      {loading ? (
        <BlockSkeleton />
      ) : (
        <Bar
          data={data}
          options={{
            maintainAspectRatio: false,
            responsive: true,
            indexAxis: "y",
            plugins: {
              datalabels: {
                formatter: function (value, index, values) {
                  if (value === 0) {
                    value = "";
                    return value;
                  }
                },
              },
              legend: {
                display: false,
              },
              title: {
                display: true,
                text: title,
                color: "#58595b",
                font: {
                  size: 16,
                  family: "Arial",
                },
              },
            },
            scales: {
              y: {
                ticks: {
                  autoSkip: false, // Show all labels
                },
              },
            },
          }}
        />
      )}
    </div>
  );
}

export default BarGraph;
